var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGdriveDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 64.5C50.1731 64.5 64.5 50.1731 64.5 32.5C64.5 14.8269 50.1731 0.5 32.5 0.5C14.8269 0.5 0.5 14.8269 0.5 32.5C0.5 50.1731 14.8269 64.5 32.5 64.5Z",
    fill: "white",
    stroke: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6503 42.509L19.2413 45.2571C19.5719 45.8356 20.0472 46.2902 20.6051 46.6208L26.2873 36.7854H14.9229C14.9229 37.4259 15.0882 38.0665 15.4188 38.645L17.6503 42.509Z",
    fill: "#0066DA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9613 25.2143L27.2791 15.3789C26.7212 15.7095 26.246 16.1641 25.9154 16.7426L15.4188 34.9258C15.0942 35.4918 14.9233 36.1329 14.9229 36.7854H26.2873L32.9613 25.2143Z",
    fill: "#00AC47"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3178 46.6208C45.8757 46.2902 46.3509 45.8356 46.6816 45.2571L47.3428 44.1206L50.5041 38.645C50.8347 38.0665 51 37.4259 51 36.7854H39.6348L42.0531 41.5378L45.3178 46.6208Z",
    fill: "#EA4335"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.961 25.2144L38.6433 15.379C38.0854 15.0484 37.4448 14.8831 36.7836 14.8831H29.1384C28.4772 14.8831 27.8367 15.069 27.2788 15.379L32.961 25.2144Z",
    fill: "#00832D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6353 36.7854H26.2872L20.605 46.6208C21.1629 46.9514 21.8034 47.1167 22.4646 47.1167H43.4579C44.1191 47.1167 44.7596 46.9308 45.3175 46.6208L39.6353 36.7854Z",
    fill: "#2684FC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2557 25.8342L40.0074 16.7426C39.6768 16.1641 39.2015 15.7095 38.6437 15.3789L32.9614 25.2143L39.6355 36.7854H50.9792C50.9792 36.1449 50.8139 35.5043 50.4833 34.9258L45.2557 25.8342Z",
    fill: "#FFBA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGdriveDefault);
export default __webpack_public_path__ + "static/media/gdrive-default.605a537c39e82f2cda78cfcfe161ca9c.svg";
export { ForwardRef as ReactComponent };